import { render, staticRenderFns } from "./BaseLeftNav.vue?vue&type=template&id=83c7468c&scoped=true&"
import script from "./BaseLeftNav.vue?vue&type=script&lang=js&"
export * from "./BaseLeftNav.vue?vue&type=script&lang=js&"
import style0 from "./BaseLeftNav.vue?vue&type=style&index=0&id=83c7468c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c7468c",
  null
  
)

export default component.exports